import { h, Fragment } from 'preact';
import { formatMoney } from 'utils/format-money';
import { useProduct } from './product-context';
import parse from 'html-react-parser';

import './yotpo-reviews.css';
import { useEffect } from 'preact/hooks';

const Reviews = (activeProduct) => {
  useEffect(() => {
    if (!window['yotpo']) return;
    window['yotpo']?.refreshWidgets();
  });

  const id =
    activeProduct.id?.id?.split('/').pop() ||
    activeProduct.activeProduct?.id?.split('/').pop();
  const starsHTML = `<div class="yotpo bottomLine"
  data-appkey="d7O0ve2H4IMJzEzSBzB4qcOnwgdt4IHyoRUiRmS4"
  data-domain="carvedesigns.com" data-product-id="${id}"
  ></div>`;
  return <>{parse(starsHTML)}</>;
};

export default Reviews;
